// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__VHnu2","info":"Panel_info__Ri3M6","btns":"Panel_btns__aoT5m","button":"Panel_button__EmnWU"};